import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
        standalone: false,
    templateUrl: "./view.component.html",
})
export class UnauthorizedAccessComponent {
    message: string =
        "You are not authorised to access this page. Contact your administrator for assistance.";
    supportRequest: boolean = false;

    constructor(private activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        var security = this.activatedRoute.snapshot.queryParams.security;

        if (security) {
            let securityMessage = this.securityDictionary[security];

            if (securityMessage) this.message = securityMessage;
        }

        var error = this.activatedRoute.snapshot.queryParams.error;

        if (error) {
            let errorMessage = this.errorDictionary[error];

            if (errorMessage) this.message = errorMessage;
        }

        this.supportRequest =
            this.activatedRoute.snapshot.queryParams.error ==
            "Unauthorized-Support";
    }

    private securityDictionary = {
        rfi:
            "Oops. The provided security token has expired or already been used. Please search your Inbox for a later email containing the latest link to the RFI or, failing that, double check your junk/spam folder.",
        cvi:
            "Oops. The provided security token has expired or already been used. Please search your Inbox for a later email containing the latest link to the CVI or, failing that, double check your junk/spam folder.",
        submittal:
            "Oops. The provided security token has expired or already been used. Please search your Inbox for a later email containing the latest link to the Submittal or, failing that, double check your junk/spam folder.",
        daywork:
            "Oops. The provided security token has expired or already been used. Please search your Inbox for a later email containing the latest link to the Daywork or, failing that, double check your junk/spam folder.",
        packages:
            "Oops. The provided security token has expired or already been used. Please search your Inbox for a later email containing the latest link to the Package or, failing that, double check your junk/spam folder.",
    };

    private errorDictionary = {
        "Unauthorized-Support":
            "You must be logged in to access the support website. Please login and try again",
    };
}
